import {convertDexOrderFromApi, DexOrder, DexOrderFromApi} from '../../../components/dex/dex-streaming/types/dex-order';
import {TxHistoryRec} from '../tx-history-rec';
import {DexTrade} from './dex-trade';
import {txHistoryRecFromTransactionApi} from './transaction-api.mapper';
import {TransactionApiModel} from './transaction-api.model';

export enum DexOrderTxType {
    ORDER = 'ORDER'
}

interface DexOrderTxFromApiBase {
    id: number;
    internalOrderId?: number | null | undefined; // Internal order ID
    orderId?: string | null | undefined; // Order ID from the on-chain
    transactionId?: number | null | undefined; // Internal Transaction ID
    type: DexOrderTxType; // always "ORDER"?
    hash?: string | null | undefined; // Transaction hash
    transaction?: TransactionApiModel | null | undefined;
    order?: DexOrderFromApi | null | undefined;
    trades?: DexTrade[];
    createdAt: string; // "2026-03-22T18:26:19.000"
    updatedAt: string; // "2026-03-22T18:26:19.000"
}

export type DexOrderTxFromApi = DexOrderTxFromApiBase;

type DexOrderTxBase = Partial<Pick<DexOrderTxFromApiBase,
    'id' |
    'createdAt' |
    'updatedAt' |
    'orderId' |
    'transactionId'
>> & {
    transaction?: TxHistoryRec | null | undefined;
    order?: DexOrder | null | undefined;
    trades?: DexTrade[];
}

type ReqFromDexOrderTxBase<Base, K extends keyof Base> = Partial<Base>
    & Required<Pick<Base, K>>;

export type DexOrderTxTx = ReqFromDexOrderTxBase<DexOrderTxBase, 'transaction'>;

export type DexOrderTxOrder = ReqFromDexOrderTxBase<DexOrderTxBase, 'order' | 'trades'>;

export type DexOrderTx = DexOrderTxTx | DexOrderTxOrder;

export const convertDexOrderTxFromApi = (oTxFromApi: DexOrderTxFromApi): DexOrderTx => ({
    id:          oTxFromApi.id,
    transaction: oTxFromApi.transaction
                     ? txHistoryRecFromTransactionApi(oTxFromApi.transaction)
                     : undefined,
    order:       oTxFromApi.order
                     ? convertDexOrderFromApi(oTxFromApi.order)
                     : undefined,
    trades:      oTxFromApi.trades,
    createdAt:   oTxFromApi.createdAt,
    updatedAt:   oTxFromApi.updatedAt
});
